import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DashboardLeaderboardMenuItem } from '../dashboard.component';
import { LeaderboardService } from './leaderboard.service';
import { OrgLeaderboardNewVideosRow, OrgLeaderboardTesRow, OrgLeaderboardViewRow } from './leaderboard-api-response.model';

@Component({
    selector: 'app-leaderboard',
    templateUrl: './leaderboard.component.html',
    styleUrls: ['./leaderboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LeaderboardComponent implements OnInit {

  @Input() dashboardLbType: DashboardLeaderboardMenuItem = 'views';
  
  showOrg: boolean = false;
  isLoading: boolean = true;
  initialOrgData: OrgLeaderboardViewRow[] | OrgLeaderboardNewVideosRow[] | OrgLeaderboardTesRow[] | undefined;

  constructor(private lbService: LeaderboardService) {
  }

  ngOnInit(): void {
    this.initialLoad();
  }

  async initialLoad() {
    this.isLoading = true;
    
    // Load initial org data to check for 3 users or less
    // SM - 237 wants to hide the org tab if the org has < 3 users on it
    // Passing the initial data to the org component if showOrg is true to reduce 1 more network call.
    if (this.dashboardLbType == 'views') {
      this.initialOrgData = await this.lbService.getOrgViewsLeaderboard();  
    } else if (this.dashboardLbType == 'videos') {
      this.initialOrgData = await this.lbService.getOrgNewVideoLeaderboard();
    } else if (this.dashboardLbType == 'tes') {
      this.initialOrgData = await this.lbService.getOrgTesLeaderboard();
    }  

    this.showOrg = this.initialOrgData.length >= 3;  
    this.isLoading = false;
  }


}
